import React, { useEffect } from 'react';
import OrgRegistryBasicInfoComponent from './org-registry-basic-info.component';
import OrgRegistryKeyInfoComponent from './org-registry-key.component';
import OrgRegistryBrandInfoComponent from './brand-mapping/org-registry-brand-Info.component';
import TabContainer from '../../../../../../../../common/components/tab/containers/tab.containers';
import { useSearchParams } from 'react-router-dom';


export const OrgRegistryComponent = ({dbnpregistries,
  deliveryPreference, accountType, deleteKeys, onFormItemChange, keys, onFormChange, orgRegistry, fetchAcount, accounts,
  shippingProviders, id, selectedOrgRegistry, shippingTypes, back, handleFormSubmit, changeImage, deleteSelectedBrands,
  getIsFavRecordDeletable, onFormFavItemChange, deleteselectedFavIcon, changeFavImage, logoFiles, onFormLogoItemChange,
  getIsLogoRecordDeletable, faviconSize, changeLogoImage, logoBackground, deleteselectedLogo, onFormItemBrandChange,
  getIsBrandRecordDeletable, brandMappings, handleOpen, handleClose
}: any) => {
 const [selectedTabIndex, setSelectedTabIndex] = React.useState<number | null>(null);
      const [searchParams, setSearchParams] = useSearchParams();
  const tabItems = [
    {
      id: 1,
      title: 'Basic Info',
      component: <OrgRegistryBasicInfoComponent
        id={id}
        selectedOrgRegistry={selectedOrgRegistry}
        shippingTypes={shippingTypes}
        shippingProviders={shippingProviders}
        accounts={accounts}
        accountType={accountType}
        deliveryPreference={deliveryPreference}
        fetchAcount={fetchAcount}
        orgRegistry={orgRegistry}
        onFormChange={onFormChange}
        dbnpregistries={dbnpregistries}
      />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Key Info',
      component: <OrgRegistryKeyInfoComponent
        keys={keys}
        onFormItemChange={onFormItemChange}
        deleteKeys={deleteKeys}
      />,
      isVisible: true,
    },
    {
      id: 4,
      title: 'Brand Mapping',
      component: <OrgRegistryBrandInfoComponent
        changeImage={changeImage}
        deleteSelectedBrands={deleteSelectedBrands}
        getIsBrandRecordDeletable={getIsBrandRecordDeletable}
        handleClose={handleClose}
        handleOpen={handleOpen}
        onFormItemBrandChange={onFormItemBrandChange}
        logoFiles={logoFiles}
        changeFavImage={changeFavImage}
        deleteselectedFavIcon={deleteselectedFavIcon}
        onFormFavItemChange={onFormFavItemChange}
        getIsFavRecordDeletable={getIsFavRecordDeletable}
        onFormLogoItemChange={onFormLogoItemChange}
        getIsLogoRecordDeletable={getIsLogoRecordDeletable}
        faviconSize={faviconSize}
        changeLogoImage={changeLogoImage}
        logoBackground={logoBackground}
        deleteselectedLogo={deleteselectedLogo}
        brandMappings={brandMappings}
      />,
      isVisible: id > 0 ? true : false,
    },
  ]
 useEffect(() => {
            const tabTitleFromURL = searchParams.get('tab');
            if (tabTitleFromURL) {
                const tabIndex = tabItems.findIndex(tab => tab.title === tabTitleFromURL);
                if (tabIndex !== -1) {
                    setSelectedTabIndex(tabIndex);
                }
            } else {
                setSelectedTabIndex(0);
            }
        }, [searchParams]);
    
        const handleTabChange = (index: number) => {
            setSelectedTabIndex(index);
            setSearchParams({ tab: tabItems[index].title });
        };
    
        if (selectedTabIndex === null) {
            return null;
        }
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems}   selectedIndex={selectedTabIndex}
            onChange={handleTabChange} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        </div>
    </div>
  )
}
export default OrgRegistryComponent;
